import React from 'react'
import { Search } from '../Search'
import type { DataTableSearchProps } from './DataTable.types'

const DataTableSearch: React.FC<DataTableSearchProps> = ({
  showFilter = true,
  ariaLabel = 'Search table',
  className = '',
  ...props
}) => (
  <Search
    {...props}
    showFilter={showFilter}
    ariaLabel={ariaLabel}
    className={['ds-data-table-search', className].filter(Boolean).join(' ')}
  />
)

export default DataTableSearch
